import { jsx as _jsx } from "react/jsx-runtime";
export default (function () { return _jsx("h2", { children: "404 Page Not Found" }); });
